import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const programs = [{
  title: 'Petits Lions',
  age: '3–5 ans',
  description: "Cours ludiques axés sur le développement moteur, la coordination, l'écoute et le contrôle de l'énergie par le jeu.",
  image: 'https://cdn.magicpatterns.com/uploads/ugY87LuBQWbp5u1hUGxbeV/image.png'
}, {
  title: 'Lions Jeunes',
  age: '6–12 ans',
  description: 'Un programme structuré qui développe la confiance, la discipline, le respect et les bases solides du Taekwondo.',
  image: 'https://cdn.magicpatterns.com/uploads/sXRDJ5H9j9sq5w3zGhJEFN/image.png'
}, {
  title: 'Adolescents & Adultes',
  age: '13 ans et +',
  description: "Entraînement dynamique pour améliorer la condition physique, apprendre l'autodéfense et renforcer la discipline mentale.",
  image: 'https://cdn.magicpatterns.com/uploads/azaaRX4JBqP6uVacUVV6Yd/image.png'
}, {
  title: 'Cours privés (Mise en forme, Taekwondo, Kickboxing)',
  age: 'Tous âges',
  description: 'Séances personnalisées avec nos entraîneurs experts pour améliorer votre forme physique et vos compétences en arts martiaux.',
  image: 'https://cdn.magicpatterns.com/uploads/j7FwnFR7QrLKAheVoEVz1U/image.png'
}];
export function ProgramsSection() {
  return <section className="py-24 bg-neutral-50" data-id="element-126">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="text-center mb-16" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-4" data-id="element-129">
            Nos Programmes
          </h2>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto" data-id="element-130">
            Des cours adaptés pour chaque étape de la vie, du développement
            moteur des tout-petits à la maîtrise technique des adultes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-131">
          {programs.map((program, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300 flex flex-col h-full group" data-id="element-132">
              <div className="h-48 overflow-hidden relative" data-id="element-133">
                <img src={program.image} alt={program.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-134" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-60" data-id="element-135"></div>
                <div className="absolute bottom-4 left-4 text-white" data-id="element-136">
                  <span className="text-xs font-bold uppercase tracking-wider bg-red-600 px-2 py-1 rounded-md mb-2 inline-block" data-id="element-137">
                    {program.age}
                  </span>
                </div>
              </div>

              <div className="p-6 flex flex-col flex-grow" data-id="element-138">
                <h3 className="text-xl font-bold text-neutral-900 mb-3" data-id="element-139">
                  {program.title}
                </h3>
                <p className="text-neutral-600 text-sm mb-6 flex-grow leading-relaxed" data-id="element-140">
                  {program.description}
                </p>
                <button className="flex items-center text-red-600 font-semibold text-sm group-hover:text-red-700 transition-colors mt-auto" data-id="element-141">
                  En savoir plus
                  <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-142" />
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}